import { toast } from "react-hot-toast";
import AccountForm from "../../components/forms/account-form";
import Header from "../../components/header";
import { useAuth } from "../../contexts/AuthContext";
import { DialogEnum, useDialog } from "../../contexts/DialogContext";
import {
  CreateAccountFormValues,
  useCreateAccountForm,
} from "../../forms/account/create-account-form";

export default function CreateAccount() {
  const createAccountForm = useCreateAccountForm();
  const { signUp } = useAuth();
  const dialog = useDialog();

  const onRegisterSubmit = async (values: CreateAccountFormValues) => {
    try {
      await signUp(values);
      dialog.push(DialogEnum.CONFIRM_REGISTRATION);
    } catch (e) {
      toast.error(e as string);
    }
  };

  return (
    <>
      <Header>
        <div className="container w-full mx-auto">
          <div className="container h-[80px] mx-auto text-3xl text-white font-semibold flex items-center">
            Create Account
          </div>
        </div>
      </Header>
      <AccountForm
        onSubmit={onRegisterSubmit}
        form={createAccountForm}
        mode="create"
      />
    </>
  );
}
